import React from 'react';


const OrderCard = ({order}) => {
    console.log(order.state)
    return (
        <div className="col-md-4 mt-4 p-4 me-3" style={{background: 'white', width: '500px', borderRadius: '10px'}}>
            <div className="d-flex justify-content-between">
                <img src={`data:image/png;base64,${order.img.img}`} className="img-fluid mb-3" />
                <div className={`alert alert-${order.state}`} role="alert"></div>
            </div>
            <h4>{order.title}</h4>
            <p>{order.description}</p>
        </div>
    );
};

export default OrderCard;